module.exports = __webpack_public_path__ + "static/img/5.3229f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.png
// module id = 2Pfm
// module chunks = 1